"use client";

import "@/public/globals.css";
import { GameProvider } from "@/app/providers/GameContextProvider";
import { MainMapProvider } from "@/app/providers/MainMapContextProvider";
import { LocaleProvider } from "@/app/providers/LocalContextProvider";
import { GlobalPopupProvider } from "../providers/GlobalPopupProvider";
import { PhotosphereQualityProvider } from "@/app/providers/PhotosphereQualityProvider";
import { GameQualityProvider } from "@/app/providers/GameQualityProvider";
import { AudioProvider } from "@/app/providers/AudioProvider";
import Script from "next/script";
import { useIsMobile } from "@/hooks/useIsMobile";


export default function RootLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    const isMobile = useIsMobile();
    return (
        <html lang="en">
            <body className={`w-screen h-screen ${isMobile ? "is-mobile" : ""}`}>
                <Script src="/env-config.js" strategy="beforeInteractive" />
                <LocaleProvider>
                    <GlobalPopupProvider>
                        <AudioProvider>
                            <GameQualityProvider>
                                <PhotosphereQualityProvider>
                                    <MainMapProvider>
                                        <GameProvider>
                                            {children}
                                        </GameProvider>
                                    </MainMapProvider>
                                </PhotosphereQualityProvider>
                            </GameQualityProvider>
                        </AudioProvider>
                    </GlobalPopupProvider>
                </LocaleProvider>
            </body>
        </html>
    );
}
